import type { JSX } from "react";
import { Icon } from "./Icon";

interface GlobeProps {
  color?: string;
}

export const Globe = ({ color }: GlobeProps): JSX.Element => {
  return (
    <Icon
      title="icons.globe"
      height={16}
      width={16}
      color={color}
      d="M7.82222 0C3.50213 0 0 3.50213 0 7.82222C0 12.1423 3.50213 15.6444 7.82222 15.6444C12.1423 15.6444 15.6444 12.1423 15.6444 7.82222C15.6444 3.50213 12.1423 0 7.82222 0ZM14.56 7.46667H12.0889C11.9822 5.13067 10.9902 2.74133 9.32978 1.24089C12.2667 1.91715 14.4005 4.45707 14.56 7.46667ZM7.11111 1.81689V7.46667H4.62222C4.72533 5.23733 5.60356 3.06133 7.11111 1.81689ZM7.11111 8.53333V13.7707C5.70667 12.5333 4.82489 10.5244 4.62222 8.53333H7.11111ZM8.17778 13.9342V8.53333H11.0222C10.7876 10.5564 9.73867 12.6898 8.17778 13.9342ZM8.17778 7.46667V1.664C9.856 2.90489 10.9049 5.21956 11.0222 7.46667H8.17778ZM6.09778 1.29778C4.54044 2.77689 3.65156 5.10222 3.55556 7.46667H1.08444C1.2409 4.54074 3.26568 2.04926 6.09778 1.29778ZM1.12 8.53333H3.56978C3.76889 10.7093 4.704 12.9244 6.21156 14.3716C3.45076 13.6936 1.40978 11.3598 1.10578 8.53333H1.12ZM9.26222 14.4249C10.8854 12.8651 11.8948 10.7745 12.1067 8.53333H14.5956C14.2684 11.4442 12.1136 13.8182 9.248 14.4249H9.26222Z"
    />
  );
};

export default Globe;
